import script from "./CarouselUnico.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselUnico.vue?vue&type=script&setup=true&lang=js"

import "./CarouselUnico.vue?vue&type=style&index=0&id=afa9d546&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afa9d546"]])

export default __exports__